module.exports = __webpack_public_path__ + "img/矩形 87@1x.559677dd.png";